import { Heading } from '@/components/typography/heading/heading.component';
import { type TypographyElements } from '@/components/typography/typography.types';
import { type ComponentProps } from 'react';

type HeaderProps = ComponentProps<typeof Heading>;

type Props = Omit<HeaderProps, 'element' | 'variant'> & {
  element?: TypographyElements;
};
export const H1 = ({ element = 'h1', children, ...props }: Props) => (
  <Heading variant="title" element={element} {...props}>
    {children}
  </Heading>
);

export const H2 = ({ element = 'h2', children, ...props }: Props) => (
  <Heading variant="heading2" element={element} {...props}>
    {children}
  </Heading>
);

export const H3 = ({ element = 'h3', children, ...props }: Props) => (
  <Heading variant="heading3" element={element} {...props}>
    {children}
  </Heading>
);

export const HTable = ({ element = 'p', children, ...props }: Props) => (
  <Heading variant="tableHeading" element={element} {...props}>
    {children}
  </Heading>
);

export const Subtitle = ({ element = 'h2', children, ...props }: Props) => (
  <Heading variant="subTitle" element={element} {...props}>
    {children}
  </Heading>
);
